import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/Home.vue'),
    meta: { title: 'Qintro - Your digital business card, made easier.' }
  },
  {
    path: '/qr/:id',
    name: 'qr',
    component: () => import('../views/QrCard.vue'),
    meta: { title: 'Scanned Card Details' }
  },
  {
    path: '/create',
    name: 'create',
    component: () => import('../views/Create.vue'),
    meta: { title: 'Qintro - Create' }
  },
  {
    path: '/edit/:id',
    name: 'edit',
    component: () => import('../views/Edit.vue'),
    meta: { title: 'Email sent with the required edit link' }
  },
  {
    path: '/customize',
    name: 'customize',
    component: () => import('../views/Customize.vue'),
    meta: { title: 'Qintro - Customize' }
  },
  {
    path: '/email',
    name: 'email',
    component: () => import('../views/Email.vue'),
    meta: { title: 'Qintro - Email' }
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: () => import('../views/Policy.vue'),
    meta: { title: 'Qintro - Privacy Policy' }
  },
  {
    path: '*',
    name: '404 Error',
    component: () => import('../views/404.vue'),
    meta: { title: '404 Error Page' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  next()
});

export default router
